module.exports = __webpack_public_path__ + "media/images/search-icons/faq-2feb882c7680006515a5a8877f2f3acd.png";